import { Autocomplete, TextField } from '@mui/material';

export type SwitcherOption = { email: string; label?: string; orgId?: string };

type Props<T extends SwitcherOption> = {
  value: T | null;
  onChange: (option: T | null) => void;
  options: T[];
  label?: string;
  disabled?: boolean;
};

// presentational user picker shared by the profile modal and the logged-out page
const UserQuickSwitcher = <T extends SwitcherOption>({
  value,
  onChange,
  options,
  label = 'Account',
  disabled,
}: Props<T>) => {
  if (!options.length) return null;

  return (
    <Autocomplete
      value={value}
      options={options}
      disabled={disabled}
      size="small"
      getOptionLabel={option => option.label ?? option.email}
      isOptionEqualToValue={(a, b) => a.email === b.email && a.orgId === b.orgId}
      renderInput={params => <TextField {...params} name="quickSwitchUser" label={label} />}
      onChange={(_, val) => onChange(val)}
    />
  );
};

export default UserQuickSwitcher;
